import { Button } from '@tailwindComponents/Button';
import { FloxSpinner } from '@tailwindComponents/FloxSpinner';
import { WingmanEmbedStatus } from './useWingmanEmbed';

/* The one connecting/unavailable overlay for every Wingman embed surface (the full-page board and
   the global slide-out panel) — the two used to carry drifting copies of this JSX. */

export function WingmanEmbedOverlay({
  embedStatus,
  onRetry,
}: {
  embedStatus: WingmanEmbedStatus;
  onRetry: () => void;
}) {
  if (embedStatus === 'ready') {
    return null;
  }
  return (
    <div className='absolute inset-0 flex items-center justify-center bg-white'>
      {embedStatus === 'connecting' ? (
        <div className='flex flex-col items-center gap-3'>
          <FloxSpinner size='md' />
          <p className='text-sm text-gray-500'>Connecting to Wingman...</p>
        </div>
      ) : (
        <div className='text-center'>
          <p className='text-sm font-medium text-gray-900'>
            Wingman is unavailable right now
          </p>
          <p className='mt-1 text-sm text-gray-500'>
            The service may be starting up or offline. Please try again in a
            moment.
          </p>
          <Button
            label='Try again'
            intent='secondary'
            className='mt-4'
            onClick={onRetry}
          />
        </div>
      )}
    </div>
  );
}
